import { createAsyncThunk } from "@reduxjs/toolkit";
import { ProcurementAxios } from "api/ProcurementAxios";
import { WarehouseAxios } from "api/WarehouseAxios";
import { Axios } from "api/axios";
import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import axios from "axios";
import Header from "Layout/Header";
const BASE_URL = "/packing/";

export const createWarehousePacking = createAsyncThunk(
  "warehouse/createWarehousePacking",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`${API_ENDPOINT.WAREHOUSE.PACKING.CREATE}`, payload);
      return response?.data?.data || response?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchWarehousePackingDone = createAsyncThunk(
  "warehouse/fetchWarehousePackingDone",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    search_type,
    filters,
    type,
    warehouse_id,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    search_type?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    type?: string;
    warehouse_id?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    params.append("warehouse_id", warehouse_id);
    if (search) params.append("search", search);
    if (search_type) params.append("search_type", search_type);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    const filterPayload = FilterBuilder(filters ?? []);

    const body = {
      filters: filterPayload,
      ...(search_type ? { search_type } : {}),
    };

    const response: any = await Axios.post(
      `${API_ENDPOINT.WAREHOUSE.PACKING_DONE.LIST}?${params.toString()}`,
      body
    );

    // return {
    //   data: response?.data?.results || [],
    //   rowCount: response.data.count || 0,
    // };

    // console.log("type : ", type)

    // if (type === 'Transfer') {
    //   const response: any = await WarehouseAxios.get(
    //     `${BASE_URL}packing-done/list/?warehouse_id=${warehouse_id}&${params.toString()}`
    //   );

    //   console.log("RES : ", response.data.count)
    //   return {
    //     data: response?.data.data || [],
    //     rowCount: response.data.total_records || 0,
    //   };
    // } else if (type === 'Allocation') {
    //   const response: any = await WarehouseAxios.get(
    //     `${BASE_URL}packing-done/list/?allocation_packing_type=Allocation&warehouse_id=${warehouse_id}&${params.toString()}`
    //   );

    return {
      data: response?.data?.data || response?.data,
      rowCount: response?.data?.count || 0,
    };
  }
);

export const fetchWarehousePackingById = createAsyncThunk(
  "warehouse/fetchWarehousePackingById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await WarehouseAxios.get(
        API_ENDPOINT?.WAREHOUSE?.PACKING_DONE?.DETAIL(id)
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateWarehousePacking = createAsyncThunk(
  "warehouse/updateWarehousePacking",
  async (
    { id, formData }: { id: any; formData: FormData },
    { rejectWithValue }
  ) => {
    try {
      const response = await Axios.put(`${API_ENDPOINT.WAREHOUSE.PACKING_DONE.UPDATE(id)}`,
        formData
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const deleteWarehousePacking = createAsyncThunk(
  "warehouse/deleteWarehousePacking",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await WarehouseAxios.delete(`${BASE_URL}${id}/delete/`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchWarehousePackingDropdown = createAsyncThunk(
  "warehouse/fetchWarehousePackingDropdown",
  async (params: any = {}, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();
      if (params) {
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            queryParams.append(key, String(value));
          }
        });
      }

      const response = await WarehouseAxios.get(
        `${BASE_URL}dropdown/?${queryParams.toString()}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const exportPackingyCSV = async ({
  search,
  filters,
  warehouse_id,
}: {
  search?: string;
  warehouse_id?: string;
  filters?: {
    filterField: string;
    filterValue: any;
  }[];
}) => {
  const params = new URLSearchParams();

  if (search) params.append("search", search);
  if (warehouse_id) params.append("warehouse_id", warehouse_id);

  // -----------------------------
  // Build structured filters body
  // -----------------------------
  const filterPayload = FilterBuilder(filters ?? []);

  const body = {
    filters: filterPayload,
  };

  const response = await Axios.post(
    `${API_ENDPOINT.WAREHOUSE.PACKING_DONE.EXPORT}?${params.toString()}`,
    body,
    { responseType: "blob" }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") ||
      `Packing_${new Date().toISOString().split("T")[0]}.csv`,
  };
};

export const handleRevertPackingDone = createAsyncThunk(
  "warehouse/handleRevertPackingDone",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(API_ENDPOINT.WAREHOUSE.PACKING_DONE.REVERT(id));
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
